import React from "react"
import { CustomReasonCode, Maybe, Reason } from "lib/types/generated/graphql-types"
import {
  Code,
  Comment,
  Container,
  DeleteButton,
  ExpandIcon,
  Info,
  Remove
} from "./AddedReason.styled"
import { ReactComponent as CommentIcon } from "images/icons/comment-lines.svg"
import { ReactComponent as TagIcon } from "images/icons/tag.svg"
import { ReactComponent as TrashIcon } from "images/icons/trash-can.svg"
import { ReactComponent as ChevronDown } from "images/icons/chevron-down.svg"
import { ReactComponent as ChevronUp } from "images/icons/chevron-up.svg"

type Props = {
  reason: Maybe<Reason> | undefined
  removeReason?: () => void
  loading?: boolean
  getCustomCode: (code: Maybe<string> | undefined) => CustomReasonCode | undefined
  disableDelete?: boolean
}

const AddedReason = ({ reason, removeReason, loading, getCustomCode, disableDelete }: Props) => {
  const [expanded, setExpanded] = React.useState(false)
  const customCode = getCustomCode(reason?.code)

  const handleRemove = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    removeReason && removeReason()
  }

  if (!reason?.code || !reason.cause) return <div>- No reason added</div>

  return (
    <Container
      onClick={() => setExpanded(!expanded)}
      className={loading ? "blur" : ""}
      $disableDelete={disableDelete}
    >
      <Info>
        {reason?.code && (
          <Code>
            <span>
              <TagIcon />
              <b>{customCode ? `${customCode.code} - ${customCode.label}` : reason.code}</b>
            </span>
          </Code>
        )}
        {reason?.cause && (
          <Comment>
            <CommentIcon />
            {reason?.cause}
          </Comment>
        )}
        {expanded && !disableDelete && (
          <Remove>
            <DeleteButton onClick={(e) => handleRemove(e)}>
              <TrashIcon />
              Remove
            </DeleteButton>
          </Remove>
        )}
        {!disableDelete && <ExpandIcon>{expanded ? <ChevronUp /> : <ChevronDown />}</ExpandIcon>}
      </Info>
    </Container>
  )
}

export default AddedReason
